import React, { useState } from "react";

export default function PesquisaArtigo() {
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const handleFeedback = () => {
    setFeedbackMessage("Obrigado pelo seu feedback!");
  };

  const handleContactClick = () => {
    // Dispara o evento personalizado para abrir o WhatsApp
    window.dispatchEvent(new Event("openWhatsAppWidget"));
  };

  return (
    <section>
      <div className="article-votes">
        <span className="article-votes-question">Esse artigo foi útil?</span>

        <div className="article-votes-controls" role="radiogroup">
          {["Sim", "Não"].map((label) => (
            <button
              key={label}
              className="button article-vote nav-link"
              aria-selected="false"
              role="radio"
              onClick={handleFeedback}
            >
              {label}
            </button>
          ))}
        </div>

        {feedbackMessage && (
          <small>
            <p>{feedbackMessage}</p>
          </small>
        )}

        <small>
          Este formulário é usado apenas para feedback de documentação.
        </small>
      </div>

      <div className="article-more-questions article-votes">
        <p>Ainda precisa de Ajuda? Estamos aqui para te ajudar.</p>
        <p>
          <a
            href="#contact_page_link"
            onClick={handleContactClick}
            id="contact_page_link"
            className="nav-item"
          >
            Entrar em Contato
          </a>
        </p>
      </div>
    </section>
  );
}
